<template>
<div class="time">
  <div class="time_title">
    <div class="time_title_cont">首发集团京开分公司</div>
    <div class="time_date">{{nowDate}}</div>
  </div>
  <!-- 本地新闻 -->
  <div class="time_left_top">
  <newMons/>
  </div>
  <div class="time_zhong_top">
  <div class="specialAttention">
    <div class="head">
      <div class="bodyTitle">
      <!-- <img src="../assets/Starting/img-hotspot/logo.png" /> -->
        <div class="pageTitle">集团新闻</div>
   
      </div>
    </div>
    <div class="main">
      <div class="cilre">
        <div @click="pauseOrPlay()" class="eventBtn" v-show="true">
          <div class="stop" id="eventBtn"></div>
        </div>
      </div>
      <ul class="news" id="news">
        <li
          :data-topic_id="index"
          :key="index"
          @click="showDialog(item)"
          class="newslist animated fadeInDown"
          v-for="(item, index) in active_data"
        >
          <div class="news-box">
            <div class="r info">
              {{ item.newsTime.slice(0, 10) | temp_filter }}
            </div>
            <!-- <div class="r info">
              {{ item.title | temp_filter }}
            </div> -->
            <h5  @click="goind(item,item.text,item.CONTENT)" >{{ item.title | temp_filter }}</h5>
             <p @click="goind(item)" class="textp">{{item.content}}</p>
          </div>
        </li>
      </ul>
    </div>

  </div>
   </div>
   <!-- 热点分析3.0 -->
  <div class="time_right_top">
    <hotspots/>
  </div>

  <!-- 京开咨询 -->
 <div class="time_left_bottom">
   <Informations/>
 </div>
  <!-- 视频汇集 -->
  <div class="time_zhong_bottom">
  <videoes/>
  </div>
  <!-- 全国交通热点 -->
  <div class="time_right_bottom">
  <mapTimess/>
  </div>

   <!--热点新闻 弹出框 -->
         <el-dialog
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">
   <div class="body_tiele">{{this.list.title}} <img class="body_img" @click="goindr(list.url)" src="@/assets/lian.png" alt=""> </div>
    <div class="live">{{this.list.source }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{this.list.newsTime}}<div></div></div>
    <div  class="body_cont">{{this.list.content }}
        <div class="time_img" >
        <div class="wx_img" v-for="(item,index) in imgs" :key="index">
        <img v-if="item.imgUrl!=''" class="img_wx" :src="item.imgUrl" alt="">
        </div>
        </div>
    </div>
  <span slot="footer" class="dialog-footer">
    
  </span>
</el-dialog>
  </div>
</template>

<script>
import newMons from '../views/timeMoon/newMons'
import hotspots from '../views/timeMoon/hotspots3.0'
import Informations from '../views/timeMoon/Informations'
import videoes from '../views/timeMoon/videoes'
import mapTimess from '../views/timeMoon/mapTimess'
import { getNews } from "../api/re.js";
export default {
    name:'timeMon',
components:{
    newMons,
   hotspots,
   Informations,
   mapTimess,
   videoes
},
  data() {
    return {
      active_data: [],
      imageFiles: "",
      hover: null,
      update_data: null,
      showBody: "",
      show: false,
      list:{},
       dialogVisible: false,
       index:4,
        imgs:[],
     nowDate: "", // 当前日期
     data:"",
    };
  },
  filters: {
    temp_filter(value) {
      if (value) {
        return value;
      } else {
        return "";
      }
    },
  },
  created() {
  // this.websket();
    //接口
    this.lond();
    this.currentTime();
   setInterval(()=>{
     this.lond();
    },7200000)
  },
  watch:{
    //  data: {
    //   handler(newRoom, oldRoom) {
    //    this.lond();
    //   },
    //   deep: true
    // }
  },
  mounted() {
    this.pageInit();

  },

  beforeDestroy() {
    this.stopScroll(true);
  },

  methods: {
     websket() {
      // 检查浏览器是否支持SSE
      if ("EventSource" in window) {
        var source = new EventSource('http://192.168.31.156:40001/sse/connect/daxian');
        source.onmessage = function(e) {     //监听信息的传输
         this.data =e.data;
          // console.log("message1",e.data);
            // this.data = JSON.parse(e.data);
        console.log(this.data,'所接收到的信息');
        
        // origin = e.origin;
        };

        source.onopen = function(e) {   //当连接正式建立时触发
          console.log("连接打开.");

        };

        source.onerror = function(e) {  //当连接发生error时触发
          if (e.readyState == EventSource.CLOSED) {
            console.log("连接关闭");
          } else {
            console.log("onerror:" + e.readyState);
          }
        };
      } else {
        console.log("没有sse");
      }
    },
 currentTime() {
     setInterval(this.formatDate, 500);
    },
   formatDate() {
     let date = new Date();
     let year = date.getFullYear(); // 年
     let month = date.getMonth() + 1; // 月
     let day = date.getDate(); // 日
     let week = date.getDay(); // 星期
     let weekArr = [ "星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六" ];
     let hour = date.getHours(); // 时
     hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
     let minute = date.getMinutes(); // 分
     minute = minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
     let second = date.getSeconds(); // 秒
     second = second < 10 ? "0" + second : second; // 如果只有一位，则前面补零
     this.nowDate = `${year}年${month}月${day}日 ${hour}:${minute}:${second}`;
   },
  
    pageInit() {
      // this.getNews(); // 首次加载数据
      this.update_data = setInterval(() => {
        // this.getNews();
      }, 1000 * 60 * 10); // 数据刷新周期十分钟
    },
    goind(item,text,CONTENT){
       this.dialogVisible=true
      this.list=item;
    var data1=item.images
 var demArray1 =[];
var demArray1 = data1.map(item => {
     return {
        imgUrl: item
        }
      })
     this.imgs=demArray1
    },
   goindr(url) {
      window.open(url);
    },
       handleClose(done) {
       this.dialogVisible=false
      },
    showDialog(v) {
      this.showBody = v;
      this.show = true;
      // this.stopScroll();
    },
    closeDialog() {
      if (!this.show) {
        return;
      }
      this.show = false;
      var eventBtn = document.getElementById("eventBtn");
      if (eventBtn.className == "stop") {
        this.startScroll();
      }
      setTimeout(() => {
        this.showBody = "";
      }, 1200);
    },
    startScroll() {
      this.stopScroll();
      this.hover = setInterval(() => {
        // 最后一个元素前置
        let a = document.getElementsByClassName("newslist");
        let el = a[a.length - 1];
        // el.remove()
        document.getElementById("news").prepend(el);
        // 保存高亮项信息到localStorage
       if(this.index==4){
         this.index=3;
       }else if(this.index==3){
         this.index=2;
       }else if(this.index==2){
         this.index=1;
       }else if(this.index==1){
        this.index=0;
       }else if(this.index==0){
        this.index=8;
       }else if(this.index==8){
        this.index=7;
       }else if(this.index==7){
        this.index=6;
       }else if(this.index==6){
        this.index=5;
       }else if(this.index==5){
        this.index=4;
       }else if(this.index==4){
        this.index=3;
       }
        let active_el = a[0];
        let active_item = this.active_data.filter(
          (k) => k.index == active_el.dataset.index
        )[this.index];
        this.setStorage(active_item);
      }, 10000);
    },
    stopScroll() {
      clearInterval(this.hover);
      clearInterval(this.update_data);
      // clearDataUpdate && clearInterval(this.update_data);
    },
    setStorage(item) {

      
      // window.localStorage.setItem("topic_name", item.text);
      // window.localStorage.setItem("topic_info", item.CONTENT);
      // window.localStorage.setItem("topic_id", item.topic_id);
    },
    //获取数据
    lond() {
      getNews().then((res) => {
        let news = res.data.data;
        while (news.length < 9) {
          news = news.concat(news);
        }
        this.active_data = [];
        if (this.hover) {
          this.stopScroll();
        }
        // 依次放入&展示
        for (let i = 0; i < 9; i++) {
          setTimeout(() => {
            this.active_data.push(news[i]);
          }, i * 500);
        }
        // 延时展示后开始滚动
        setTimeout(() => {
          this.startScroll();
        }, news.length * 500);
      });
    },
    //暂停播放键
    pauseOrPlay() {
      var eventBtn = document.getElementById("eventBtn");
      if (eventBtn.className == "stop") {
        eventBtn.removeAttribute("stop");
        eventBtn.setAttribute("class", "play");
        this.stopScroll();
      } else {
        eventBtn.removeAttribute("play");
        eventBtn.setAttribute("class", "stop");
        this.startScroll();
      }
    },
    //改变日期格式
    getDate() {
      var nowDate = new Date();
      var year = nowDate.getFullYear();
      var month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      var day =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      var dateStr = year + "" + month + "" + day;
      return dateStr;
    },
  },
};
</script>
<style>
.time_img{
  width: 100%;
  height: 5vh;
  display: flex;
 /* justify-content: space-around; */
  align-items: center;
  flex-wrap: wrap;
}
.wx_img{
padding: 10px;
}
.img_wx{
  width:170px;
  height: 140px;
}
</style>
<style scoped lang="scss">
.time{
    width: 100%;
    height: 100%;
   background:url("../assets/lotime.png") no-repeat;
   background-size: 100% 100%;
   position: relative;
//  公共头部样式
.time_title{
  width: 100%;
  height: 9vh;
  background: url('../assets/titles.png') no-repeat;
    background-size: 100% 100%;
.time_title_cont{
  font-size: 38px;
  color: #fff;
 font-weight: 700;
  width:55%;
  height: 8vh;
  margin: 0 auto;
  text-align: center;
  line-height: 8vh;
  letter-spacing: 10px;
}
.time_date{
  width: 20%;
  height: 4vh;
  margin: 0 auto;
  text-align: center;
  line-height:4vh;
  font-size: 22px;
  color: #fff;
  position: absolute;
  right: 1%;
  top: 2%;

}
}
.head {
    margin: 0 3vw;
    display: flex;
    align-items: center;
    height: 12%;
    justify-content: space-between;
    user-select: none;
    position: relative;
    .bodyTitle {
      height: 7.4vh;
      font-size: 0.2vw;
      font-weight: bold;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
     position: relative;
     left: -20px;
      img {
        width: 20px;
        height: 20px;
      }
      .img_monitor {
        transform: rotate(180deg);
      }
      .pageTitle {
        margin: 0 0.5em;
        white-space: nowrap;
      }
    }
  }


}
//本地新闻
.time_left_top{
    width: 30%;
    height: 44%;
    position: absolute;
    left: 5%;
    margin-top: 0.5%;
    overflow: hidden;
}
//热点新闻
.time_zhong_top{
    width: 30%;
    height: 44%;
    position: absolute;
      margin-top: 0.5%;
    left: 35%;
    overflow: hidden;
  background: url("../assets/Starting/img-groupNews/expert_bg_img.jpg") no-repeat;
  background-size: 100% 100%;
.specialAttention {
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  position: relative;

  .main {
      width: 97%;
    height: 89%;
    overflow: hidden;
    margin: 3% auto;
    position: relative;
    left: 5.7%;
    .cilre {
    position: absolute;
    width: 28%;
    height: 82%;
    border-radius: 50%;
    border: 1px solid #04def7;
    left: -18.7%;
      .eventBtn {
        position: absolute;
       top: 40%;
        right: 8%;
        width: 40px;
        height: 40px;
         padding: 10px;
        border-radius: 50%;
        background-color: rgba(23, 29, 66, 0.6);
        cursor: pointer;
        div.stop {
          background-image: url("../assets/Starting/img-hot/stop.png");
        }
        div.play {
          background-image: url("../assets/Starting/img-hot/play.png");
        }
        div {
          width: 20px;
          height: 20px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
    }
    .cilre:before {
        content: "";
    position: absolute;
    width: 55%;
    height: 58%;
    border-radius: 50%;
    border: 1px solid #04def7;
    left: 27.5%;
    top: 112%;
    margin-top: -29vh;
    opacity: 0.5;
    }
    //右边
    .newslist {
      position: absolute;
      top: -500px;
      left: 0;
      opacity: 0;
      cursor: pointer;
      height: 5vh;
      line-height: 4.6vh;
      color: #fff;
      padding: 0.2vh 1.5% 1.8vh 3%;
      width: 86%;
      transition: all 0.6s;
      img {
        width: 0;
      }
      .info {
        color: #00ccff;
        text-align: right;
        white-space: nowrap;
        font-style: normal;
        font-size:0.3rem;
        margin-right: 9%;
      }
      .news-box {
        &:after {
          content: "";
          clear: both;
          display: block;
          height: 0;
          overflow: hidden;
        }
      }
      &:before {
       content: "";
    display: block;
    position: absolute;
    left: -0.2%;
    top: 17%;
    width: 3%;
    height: 40%;
        background: url("../assets/Starting/img-hot/dian.png") no-repeat center
          center;
        background-size: contain;
        border-radius: 50%;
        transform: translate(0, -50%);
      }
    }
    .newslist:nth-child(1) {
      position: absolute;
      top: 0.6%;
      left: 5.6%;
      opacity: 0.2;
      transform: translate(-6.5%, 0);
      font-size: 0.3rem;
      .news-box {
        opacity: 0.4;
      }
    }
    .newslist:nth-child(2) {
      position: absolute;
      top: 7%;
      left: 9.2%;
      opacity: 0.6;
      transform: translate(-6.5%, 0);
       font-size: 0.3rem;
      .news-box {
        opacity: 0.6;
      }
    }
    .newslist:nth-child(3) {
      position: absolute;
      top: 14.2%;
      left: 11.4%;
      opacity: 0.8;
      transform: translate(-6.5%, 0);
        font-size: 0.3rem;
      .news-box {
        opacity: 0.8;
      }
    }
    .newslist:nth-child(4) {
      position: absolute;
      top: 23.1%;
      left: 13.1%;
      opacity: 0.9;
      transform: translate(-6.5%, 0);
     font-size: 0.3rem;
      .news-box {
        opacity: 0.9;
      }
    }
    .newslist:nth-child(5) {
      position: absolute;
      top: 30%;
      left: 14.2%;
      opacity: 1;
      transform: translate(-6.5%, 0);
       font-size: 0.3rem;
      color: #f5c512;
      height: 22.6vh;
      .news-box {
        opacity: 1;
        padding: 0.8vh 1.3% 1.5vh;
        background: url("../assets/Starting/img-hot/libg.png") no-repeat;
        background-size: 100% 100%;
        height: 39%;
        overflow: hidden;
      }
      .textp {
        display: block;
        width: 90%;
      height: 53%;
        overflow: hidden;
        position: relative;
       top: -15%;
     white-space:nowrap;
overflow:hidden;
text-overflow:ellipsis;
      }
      .info {
        margin-right: 8%;
      }
    }
    .newslist:nth-child(5):before {
      background: url("../assets/Starting/img-hot/dian1.png") no-repeat center
        center;
      background-size: contain;
    }
    .newslist:nth-child(6) {
      position: absolute;
      top: 51.9%;
      left: 13.6%;
      opacity: 0.9;
      transform: translate(-6.5%, 0);
      font-size: 0.3rem;
      .news-box {
        opacity: 0.9;
      }
    }
    .newslist:nth-child(7) {
      position: absolute;
      top: 60.3%;
      left: 12.2%;
      opacity: 0.8;
      transform: translate(-6.5%, 0);
        font-size: 0.3rem;
      .news-box {
        opacity: 0.8;
      }
    }
    .newslist:nth-child(8) {
      position: absolute;
      top: 67.8%;
      left: 10.2%;
      opacity: 0.6;
      transform: translate(-6.5%, 0);
      font-size: 0.3rem;
      .news-box {
        opacity: 0.6;
      }
    }
    .newslist:nth-child(9) {
      position: absolute;
      top: 74.1%;
      left: 7.8%;
      opacity: 0.4;
      transform: translate(-6.5%, 0);
        font-size: 0.3rem;
      .news-box {
        opacity: 0.4;
      }
    }
    .newslist:nth-child(1):before,
    .newslist:nth-child(9):before {
      background-size: 70% 70%;
    }
    .newslist:nth-child(2):before,
    .newslist:nth-child(8):before {
      background-size: 80% 80%;
    }
    .newslist:nth-child(3):before,
    .newslist:nth-child(7):before {
      background-size: 90% 90%;
    }
    .r {
      float: right;
      margin-right: 4%;
    }
    h5 {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-top: -1vh;
    }
    .textp {
      display: none;
      width: 80%;
     height: 52.5%;
      font-size: 0.3rem;
      line-height: 1.2;
      color: #e9e9e9;
      margin-top: 5px;
    }
    .hidden-item {
      opacity: 0;
      filter: Alpha(opacity=0);
      z-index: -1;
    }
  }
}
}
//热点分析 
.time_right_top{
      width: 30%;
  height: 44%;
    position: absolute;
    overflow: hidden;
   left: 65%;
     margin-top: 0.5%;
     .main-middle {
      width: 90vw;
      height: 35vh;
      // background-image: url("../assets/Starting/img-groupNews/expert_bg_img.jpg");;
      background-size: 100% 100%;
      .middle-title {
        font-size: 1.15vw;
        color: #fff;
        position: relative;
        left: 10px;
        top: 18px;
      }
      #charts-line {
        width: 100%;
        height: calc(100% - 3.2vh);
      }
    }
}
// 京开咨询
.time_left_bottom{
   width: 30%;
   height: 43%;
    position: absolute;
    left: 5%;
      bottom: 3% ;
    overflow: hidden;
}
// 视频汇聚
.time_zhong_bottom{
   width: 30%;
    height: 43%;
    position: absolute;
    left: 35%;
      bottom: 3% ;
    overflow: hidden;
}
// 全国交通热点
.time_right_bottom{
   width: 30%;
    height: 43%;
    position: absolute;
     left: 65%;
     bottom: 3% ;
    overflow: hidden;
}



// 热点新闻弹框样式
.body_tiele{
  font-size: 30px;
font-family: PingFang;
font-weight: bold;
color: #FFFFFF;
line-height: 36px;
text-align: center;
}
.body_img{
  position: relative;
  left: 5px;
  cursor: pointer;
}
.live{
  width: 50%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 60px;
  margin: 0 auto;
  font-size: 18px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #60D6DD;
}
.body_cont{
  width: 90%;
  height: 60vh;
  overflow-y: scroll;
  margin: 0 auto;
  font-size: 22px;
font-family: Microsoft YaHei;
font-weight: 400;
line-height: 28px;
color: #FFFFFF;
}
</style>
